// import React, { useEffect } from 'react';
import React, { useState, useEffect } from 'react';
import {
  VIEW_PROPOSALS_SCPA,
  VIEW_PROPOSALS,
  SEARCH_CUSTOMER_BY_NUMBER,
  GET_MEDICAL_QUESTIONS,
  GET_CUSTOMER_TYPE_DOMAIN,
  RENEWAL_MANDATE_DETAILS,
  INTERMEDIARY_LIST,
  LOOKUP_FIELDUSER,
  GET_DATE_TIME,
  GET_PLAN_COVER_DETAILS,
} from './queries';
import { useQuery } from '@apollo/client';
// import {
//   updateBuyHealthPolicy,
//   updatePlanPremium,
// } from '../new-policy-issuance/health/_graphql/state';
import { updateBuyHealthPolicy,updatePlanPremium } from 'quanta-flows/modules/proposal/health/state';
//import useFetchQuery from '../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
//import Loading from '../../../lib/layout/loading';
//import Error from '../../../lib/layout/error';
import { Loading, Error } from 'quanta-flows/modules/layout';
//import useCoversAndPlans from '../../common/hooks/useCoversAndPlans';
import { useCoversAndPlans } from 'quanta-flows';
//import NewHealthPolicyIssuance from '../new-policy-issuance/health';
//import NewHealthPolicyIssuance from '../../../../../quanta-flows/src/modules/quote/new-policy-issuance/health';
import NewMotorPolicyIssuance from '../capture-details/health/two-wheeler';
//import { ClientService, Layout } from '../../../lib/layout';
import { ClientService ,Layout} from 'quanta-flows/modules/layout';
import { Card, useResponsiveParams, Text } from 'quanta-ui';

export default function ViewProposalDetailsHealth({
  customerID,
  lobCode,
  lobName,
  productName,
  productCode,
  proposalNumber,
}) {
  const reformData = (val, returnType, isString) => {
    return val && val.toString().trim() !== ''
      ? isString === undefined || isString === true
        ? `${val}`
        : val
      : returnType;
  };

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.toLowerCase() ===
        searchText?.toString()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.toLowerCase() ===
            searchText?.toString()?.toLowerCase(),
        )[`${returnType}`]
      : searchText === null || searchText === undefined
      ? ''
      : `${searchText}`;
  };

  const fetchQuery = useFetchQuery();

  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  const { loading, error, data } = useQuery(VIEW_PROPOSALS, {
    variables: {
      input: {
      customerID,
      productCode,
      proposalNumber,
      },
    },
  });
  const { loading:loadingSCPA, error:errorSCPA, data:dataSCPA } = useQuery(VIEW_PROPOSALS_SCPA, {
    variables: {
      input: {
      customerID,
      productCode,
      proposalNumber,
      },
    },
  });

  const {
    loading: loadingCustomerDetails,
    error: errorCustomerDetails,
    data: dataCustomerDetails,
  } = useQuery(SEARCH_CUSTOMER_BY_NUMBER, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
      customer_type: 'Individual',
      customer_number: customerID,
      },
    },
  });

  const {
    loading: loadingRenewalMandateData,
    error: errorRenewalMandateData,
    data: renewalMandateData,
  } = useQuery(RENEWAL_MANDATE_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
    },
  });

  const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(INTERMEDIARY_LIST);
  const useCoversAndPlansST = ({
    skip,
    insuredMembers,
    sumInsured,
    deductSumInsured,
    productCode,
    planName,
    isAllPlansRequired = false,
    imdCode,
  }) => {
    const [planData, setPlanData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const fetchQuery = useFetchQuery();
    const fetchAllPlans = async () => {
      if (
        insuredMembers &&
        sumInsured &&
        productCode &&
        planName &&
        imdCode &&
        deductSumInsured
      ) {
        try {
          const dateTime = fetchQuery({
            query: GET_DATE_TIME,
          });
          setLoading(true);
          const { data: dataTime } = await dateTime;
          const { datetimeValue } = dataTime;
          const { date } = datetimeValue;
          const getPlansAndCovers = fetchQuery({
            query: GET_PLAN_COVER_DETAILS,
            fetchPolicy: 'cache-first',
            variables: {
              input: {
              sumInsured,
              startDate: date,
              productCode,
              deductSumInsured,
              members: insuredMembers.map((insured) => {
                const { covers, ...restInsured } = insured;
                return restInsured;
              }),
                imdCode,
              },
            },
          });
          const { data: dataPlanCovers } = await getPlansAndCovers;
          let { planAndCovers } = dataPlanCovers;
          const planObj = planAndCovers?.find(
            (plan) =>
              plan?.name?.toLowerCase() === planName?.toLowerCase(),
          );
          planAndCovers = planObj
            ? [
                ...(isAllPlansRequired
                  ? planAndCovers?.filter(
                      (plan) =>
                        plan?.name?.toString()?.toLowerCase() !==
                        planName?.toString()?.toLowerCase(),
                    )
                  : []),
                {
                  ...planObj,
                  packs: planObj?.packs?.map((pack) => {
                    return {
                      ...pack,
                      addOnCovers: pack?.addOnCovers?.map(
                        (addOnCover) => {
                          let coverSelected = true;
                          pack?.index?.every((relationship) => {
                            if (
                              !insuredMembers
                                ?.find(
                                  (insured) =>
                                    insured?.relationship?.toLowerCase() ===
                                    relationship?.toLowerCase(),
                                )
                                ?.covers?.find(
                                  (cover) =>
                                    cover?.index?.toLowerCase() ===
                                      addOnCover?.index?.toLowerCase() &&
                                    cover?.name?.toLowerCase() ===
                                      addOnCover?.name?.toLowerCase(),
                                )
                            ) {
                              coverSelected = false;
                              return false;
                            }
                            return true;
                          });
                          return {
                            ...addOnCover,
                            selected: coverSelected,
                          };
                        },
                      ),
                    };
                  }),
                },
              ]
            : isAllPlansRequired
            ? [
                ...planAndCovers?.filter(
                  (plan) =>
                    plan?.name?.toString()?.toLowerCase() !==
                    planName?.toString()?.toLowerCase(),
                ),
              ]
            : [];
          setPlanData(planAndCovers);
          setLoading(false);
        } catch (error) {
          setError(error);
          setPlanData([]);
          setLoading(false);
        }
      }
    };
    useEffect(() => {
      if (!skip) {
        fetchAllPlans();
      }
    }, [
      insuredMembers?.length,
      sumInsured,
      deductSumInsured,
      productCode,
      planName,
      imdCode,
      skip,
    ]);
    return {
      loading,
      error,
      data: {
        planData,
      },
    };
  };
  const {
    loading: loadingCoversPlans,
    error: errorsCoversPlans,
    data: dataCoversPlans,
  } = productCode ==='2880'? (useCoversAndPlansST({
    skip:
      loading || loadingSCPA ||
      (error !== null && error !== undefined) ||
      data === null ||
      data === undefined,
    insuredMembers: data?.viewProposal?.insuredDetails?.map(
      (insured) => {
        return {
          relationship: insured?.relationship,
          ChasisNo: insured.ChasisNo,
          EngineNo: insured.EngineNo,
          VehicleMake: insured.VehicleMake,
          VehicleModel: insured.VehicleModel,
          vehicleRegNo: insured.vehicleRegNo
        };
      },
    ),
    sumInsured:( data?.viewProposal?.sumInsured),
    deductSumInsured:(data?.viewProposal?.deductSumInsured),
    productCode,
    planName: data?.viewProposal?.selectedPlanName?.toString(),
    imdCode: data?.viewProposal?.intermediaryDetails?.code,
  })) :
    (useCoversAndPlans({
    skip:
      loading || loadingSCPA ||
      (error !== null && error !== undefined) ||
      data === null ||
      data === undefined,
    insuredMembers: data?.viewProposal?.insuredDetails?.map(
      (insured) => {
        return {
          relationship: insured?.relationship,
          ChasisNo: insured.ChasisNo,
          EngineNo: insured.EngineNo,
          VehicleMake: insured.VehicleMake,
          VehicleModel: insured.VehicleModel,
          vehicleRegNo: insured.vehicleRegNo
        };
      },
    ),
    sumInsured: data?.viewProposal?.sumInsured?.toString(),
    productCode,
    planName: data?.viewProposal?.selectedPlanName?.toString(),
    imdCode: data?.viewProposal?.intermediaryDetails?.code,
  }));
  useEffect(() => {
    const fetchViewProposalData = async () => {
      if (
        dataCoversPlans &&
        dataCoversPlans?.planData &&
        data &&
        dataCustomerDetails &&
        dataMyIntermediaries
      ) {
        try {
          if (
            customerID?.toString()?.toLowerCase() ===
            data?.viewProposal?.customerID?.toString()?.toLowerCase()
          ) {
            const customer = dataCustomerDetails?.customer;
            let getProductQuestions = fetchQuery({
              query: GET_MEDICAL_QUESTIONS,
              fetchPolicy: 'network-only',
              variables: {
                input: {
                productCode,
                },
              },
            });
            let getCustomerDomain = fetchQuery({
              query: GET_CUSTOMER_TYPE_DOMAIN,
            });
            let { data: customerDomainData } =
              await getCustomerDomain;
            let { data: medicalQuestionaire } =
              await getProductQuestions;
            const { productQuestionList: questions } =
              medicalQuestionaire;
            if (
              data?.viewProposal?.intermediaryDetails?.fieldUserCode
            ) {
              var associatedEntityLookupQuery = fetchQuery({
                query: LOOKUP_FIELDUSER,
                variables: {
                  filter: {
                    fieldUserID: data?.viewProposal
                      ?.intermediaryDetails?.fieldUserCode
                    ? `${data?.viewProposal?.intermediaryDetails?.fieldUserCode}`
                    : '',
                  },
                },
              });
              var { data: associatedEntityLookupData } =
                await associatedEntityLookupQuery;
            }

            const { customerTypeList } = customerDomainData;
            const { myIntermediaries } = dataMyIntermediaries;
            const associatedEntityLookup =
              associatedEntityLookupData?.associatedEntityLookup;

            const plans = dataCoversPlans?.planData
              ? dataCoversPlans?.planData
              : [];
            const quoteData = {
              quoteNumber: data?.viewProposal?.quoteNumber,
              quotationType: data?.viewProposal?.businessType,
              lob: {
                lobCode: data?.viewProposal?.lob?.lobCode,
                lobName: data?.viewProposal?.lob?.lobName,
              },
              product: {
                productCode: data?.viewProposal?.product?.productCode,
                productName: data?.viewProposal?.product?.productName,
              },
              cover: {
                type: data?.viewProposal?.coverType,
                sum_insured: data?.viewProposal?.sumInsured,
                deductSumInsured:data?.viewProposal?.deductSumInsured,
                tenure: data?.viewProposal?.tenure,
              },
              //quote lane
              members: data?.viewProposal?.insuredDetails?.map(
                (insured) => {
                  return {
                    relationship: insured?.relationship,
                    gender: insured?.gender,
                    dob: insured?.dob,
                    age: insured?.age,
                    covers: insured?.covers,
                  };
                },
              ),
              location: {
                pincode:
                  customer?.communication_address?.pin_code ||
                  customer?.permanent_address?.pin_code,
                state:
                  customer?.communication_address?.state ||
                  customer?.permanent_address?.state,
                district:
                  customer?.communication_address?.district ||
                  customer?.permanent_address?.district,
                city:
                  customer?.communication_address?.city ||
                  customer?.permanent_address?.city,
                zone: data?.viewProposal?.zone,
              },
              plans,
            };

            const getIntermediaryName = (code) => {
              return myIntermediaries
                ? myIntermediaries?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode === code,
                  )?.intermediaryName
                : code;
            };

            const getBusinessLocation = (
              intermediarycode,
              locationCode,
            ) => {
              return myIntermediaries &&
                intermediarycode &&
                locationCode
                ? myIntermediaries?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode ===
                      intermediarycode,
                  )
                  ? myIntermediaries
                      ?.find(
                        (intermediary) =>
                          intermediary?.intermediaryCode ===
                          intermediarycode,
                      )
                      ?.businessLocations.find(
                        (location) => location?.code === locationCode,
                      )?.name
                  : locationCode
                : '';
            };
            updateBuyHealthPolicy({
              quotationType: reformData(quoteData?.quotationType, ''),
              intermediaryDetails: {
                code: data?.viewProposal?.intermediaryDetails?.code,
                intermediaryName: getIntermediaryName(
                  data?.viewProposal?.intermediaryDetails?.code,
                ),
                location:
                  data?.viewProposal?.intermediaryDetails?.location,
                branchOfficeName: getBusinessLocation(
                  data?.viewProposal?.intermediaryDetails?.code,
                  data?.viewProposal?.intermediaryDetails?.location,
                ),
                fieldUserCode:
                  data?.viewProposal?.intermediaryDetails
                    ?.fieldUserCode,
                fieldUserName: associatedEntityLookup?.fieldUserName
                  ? `${associatedEntityLookup?.fieldUserName}`
                  : '',
              },
              customerFetchRequiredOnLoad: true,
              isQuoteSaved: true,
              quoteData,
              planData: {
                plans,
                plansChanged: [],
              },
              quoteNumber: reformData(quoteData?.quoteNumber, ''),
              quoteStatus: reformData(quoteData?.quoteStatus, ''),
              policyNumber: reformData(
                data?.viewProposal?.policyNumber,
                '',
              ),
              employeeNumber: reformData(
                data?.viewProposal?.employeeNumber,
                '',
              ),
              proposalNumber: reformData(
                data?.viewProposal?.proposalNumber,
                '',
              ),
               //SA BT20641
               policyNumber:data?.viewProposal?.policyNumber
               ? `${data?.viewProposal?.policyNumber}`
               : '',
               //EA BT20641
              proposalStatus: reformData(
                data?.viewProposal?.proposalStatus,
                '',
              ),
              proposalPaymentType: (data?.viewProposal?.quoteNumber ==='NA' 
                  || data?.viewProposal?.quoteNumber === null )
                ? 'EPROPOSAL'
                :  data?.viewProposal?.proposalPaymentType,
              isProposalApplicableForPayment: data?.viewProposal
                ?.isApplicableForPayment
                ? data?.viewProposal?.isApplicableForPayment
                : false,
              isPolicyIssued: false,
              proposerDetailsMeta: {
                crn: reformData(customer?.cust_ref_number, ''),
                isNewCustomer: false,
                ifscCode: reformData(
                  customer?.bank_detail?.ifsc_code,
                  '',
                ),
                bankName: reformData(customer?.bank_detail?.name, ''),
                branchName: reformData(customer?.branch_name, ''),
                bankAcno: reformData(
                  customer?.bank_detail?.acc_number,
                  '',
                ),
                accountHolderName: reformData(
                  customer?.bank_detail?.acc_holder,
                  '',
                ),
                micrCode: reformData(
                  customer?.bank_detail?.micr_code,
                  '',
                ),
              },
              proposerDetails: {
                id: reformData(customer?.cust_number, ''),
                customerType: reformData(
                  customer?.cust_type?.code,
                  '',
                ),
                title: reformData(
                  customer?.indv_detail?.title?.code,
                  '',
                ),
                gender: reformData(
                  customer?.indv_detail?.gender?.code,
                  '',
                ),
                firstName: reformData(
                  customer?.indv_detail?.first_name,
                  '',
                ),
                middleName: reformData(
                  customer?.indv_detail?.middle_name,
                  '',
                ),
                lastName: reformData(
                  customer?.indv_detail?.surname,
                  '',
                ),
                fullName: reformData(
                  customer?.indv_detail?.full_name,
                  '',
                ),
                maritalStatus: reformData(
                  customer?.indv_detail?.marital_status?.code,
                  '',
                ),
                nationality: reformData(
                  customer?.indv_detail?.nationality?.code,
                  '',
                ),
                occupation: reformData(
                  customer?.indv_detail?.occupation?.code,
                  '',
                ),
                proposerDOB: reformData(
                  customer?.indv_detail?.date_of_birth,
                  '',
                ),
                panNumber: reformData(
                  customer?.indv_detail?.pan_card_number,
                  '',
                ),
                idProofType: reformData(
                  customer?.indv_detail?.id_proof_type?.code,
                  '',
                ),
                idProofNumber: reformData(
                  customer?.indv_detail?.id_proof_number,
                  '',
                ),
                permAddressLine1: reformData(
                  customer?.permanent_address?.address_line1,
                  '',
                ),
                permAddressLine2: reformData(
                  customer?.permanent_address?.address_line2,
                  '',
                ),
                permAddressLine3: reformData(
                  customer?.permanent_address?.address_line3,
                  '',
                ),
                permLandmark: reformData(
                  customer?.permanent_address?.land_mark,
                  '',
                ),
                permPincode: reformData(
                  customer?.permanent_address?.pin_code,
                  '',
                ),
                permCityTownVillage: reformData(
                  customer?.permanent_address?.city,
                  '',
                ),
                permDistrict: reformData(
                  customer?.permanent_address?.district,
                  '',
                ),
                permState: reformData(
                  customer?.permanent_address?.state,
                  '',
                ),
                permCommAddressYN: customer?.comm_equal_perm,
                commAddressLine1: reformData(
                  customer?.communication_address?.address_line1,
                  '',
                ),
                commAddressLine2: reformData(
                  customer?.communication_address?.address_line2,
                  '',
                ),
                commAddressLine3: reformData(
                  customer?.communication_address?.address_line3,
                  '',
                ),
                commLandmark: reformData(
                  customer?.communication_address?.land_mark,
                  '',
                ),
                commPincode: reformData(
                  customer?.communication_address?.pin_code,
                  '',
                ),
                commCityTownVillage: reformData(
                  customer?.communication_address?.city,
                  '',
                ),
                commDistrict: reformData(
                  customer?.communication_address?.district,
                  '',
                ),
                commState: reformData(
                  customer?.communication_address?.state,
                  '',
                ),
                mobileNo: reformData(customer?.contact?.mobile, ''),
                emailID: reformData(customer?.contact?.email),
                orgName: reformData(
                  customer?.org_detail?.org_name,
                  '',
                ),
                orgType: reformData(
                  customer?.org_detail?.org_type?.code,
                  '',
                ),
                contactName: reformData(
                  customer?.org_detail?.contact_name,
                  '',
                ),
                regNumber: reformData(
                  customer?.org_detail?.reg_number,
                  '',
                ),
                tanNumber: reformData(
                  customer?.org_detail?.tan_number,
                  '',
                ),
                employeeNumber: reformData(
                  customer?.indv_detail?.employeeNumber,
                  '',
                ),
                gstNumber: reformData(
                  getDomainData(
                    customerTypeList,
                    customer?.cust_type?.code,
                    'code',
                    'value',
                  )?.toLowerCase() === 'individual'
                    ? customer?.indv_detail?.gst_number
                    : customer?.org_detail?.gst_number,
                  '',
                ),
                phoneNo: reformData(customer?.contact?.telephone, ''),
                faxNo: reformData(customer?.contact?.fax_number, ''),
                altPhoneNo: reformData(
                  customer?.contact?.alt_telephone,
                  '',
                ),
                altMobileNo: reformData(
                  customer?.contact?.alt_mobile,
                  '',
                ),
              },
              sameNomineeForAllInsured: false,
              isHealthDeclarationSelected: data?.viewProposal
                ?.isHealthDeclarationSelected
                ? 'Yes'
                : 'No',
              insuredDetails: dataSCPA?.viewProposalSCPA?.insuredDetails,
              //data?.viewProposal?.insuredDetails,
                // ? data?.viewProposal?.insuredDetails?.map(
                //     (insured) => {
                //       if (insured?.age) {
                //         const { age, covers, ...rest } = insured;
                //         return rest;
                //       }
                //       return insured;
                //     },
                //   )
                // : [],
              nomineeDetails: data?.viewProposal?.nomineeDetails
                ? data?.viewProposal?.nomineeDetails
                : [],
              portabilityDetails: data?.viewProposal
                ?.portabilityDetails
                ? data?.viewProposal?.portabilityDetails
                : [],
              prevInsuranceDetails: data?.viewProposal
                ?.prevInsuranceDetails
                ? data?.viewProposal?.prevInsuranceDetails
                : [],
              renewalMandateDetails: data?.viewProposal
                ?.renewalMandateDetails
                ? {
                    renewalPaymentMandate:
                      data?.viewProposal?.renewalMandateDetails
                        ?.renewalPaymentMandate,
                    renewalPaymentMandateTakenInNameOf:
                      data?.viewProposal?.renewalMandateDetails
                        ?.renewalPaymentMandateTakenInNameOf,
                    termForMandateOpted: getDomainData(
                      renewalMandateData?.PRD_TermForMandate,
                      data?.viewProposal?.renewalMandateDetails
                        ?.termForMandateOpted,
                      'code',
                      'code',
                    ),
                    typeOfDebit: getDomainData(
                      renewalMandateData?.typeOfDebit,
                      data?.viewProposal?.renewalMandateDetails
                        ?.typeOfDebit,
                      'code',
                      'code',
                    ),
                    accountNumber:
                      data?.viewProposal?.renewalMandateDetails
                        ?.accountNumber,
                    destinationBankName:
                      data?.viewProposal?.renewalMandateDetails
                        ?.destinationBankName,
                    destinationIfscCode:
                      data?.viewProposal?.renewalMandateDetails
                        ?.destinationIfscCode,
                    destinationMicrCode:
                      data?.viewProposal?.renewalMandateDetails
                        ?.destinationMicrCode,
                    destinationBranchName:
                      data?.viewProposal?.renewalMandateDetails
                        ?.destinationBranchName,
                    mandateAmount: parseFloat(
                      data?.viewProposal?.renewalMandateDetails
                        ?.mandateAmount,
                    ),
                    finalCollectionDate:
                      data?.viewProposal?.renewalMandateDetails
                        ?.finalCollectionDate,
                    destinationBankAccountType: getDomainData(
                      renewalMandateData?.destinationBankAccountType,
                      data?.viewProposal?.renewalMandateDetails
                        ?.destinationBankAccountType,
                      'code',
                      'code',
                    ),
                  }
                : {},
              medicalQuestionaire: data?.viewProposal
                ?.medicalQuestionaire
                ? data?.viewProposal?.medicalQuestionaire?.map(
                    (medicalQuestionaireObj) => {
                      return {
                        relationship:
                          medicalQuestionaireObj?.relationship,
                        questions: [
                          {
                            srNo: 'MASTER',
                            answer: {
                              checkboxAnswer:
                                medicalQuestionaireObj?.questions
                                  ?.length > 0 ||
                                medicalQuestionaireObj?.areYouCurrentlyInGoodMentalAndPhysicalHealth
                                  ? !questions?.find(
                                      (q) =>
                                        q?.srNo?.toLowerCase() ===
                                        'master',
                                    )?.condToChild
                                    ? 'No'
                                    : 'Yes'
                                  : !questions?.find(
                                      (q) =>
                                        q?.srNo?.toLowerCase() ===
                                        'master',
                                    )?.condToChild
                                  ? 'Yes'
                                  : 'No',
                              answerText:
                                medicalQuestionaireObj?.questions
                                  ?.length > 0 ||
                                medicalQuestionaireObj?.areYouCurrentlyInGoodMentalAndPhysicalHealth
                                  ? !questions?.find(
                                      (q) =>
                                        q?.srNo?.toLowerCase() ===
                                        'master',
                                    )?.condToChild
                                    ? 'No'
                                    : 'Yes'
                                  : !questions?.find(
                                      (q) =>
                                        q?.srNo?.toLowerCase() ===
                                        'master',
                                    )?.condToChild
                                  ? 'Yes'
                                  : 'No',
                              textareaAnswer: '',
                            },
                          },
                          ...medicalQuestionaireObj?.questions?.map(
                            (q) => {
                              const questionObj = questions?.find(
                                (question) =>
                                  question?.srNo?.toLowerCase() ===
                                  q?.srNo?.toLowerCase(),
                              );
                              return {
                                ...q,
                                answer: {
                                  checkboxAnswer:
                                    questionObj?.isChkReq &&
                                    !questionObj?.isChkTxtReq
                                      ? q?.answer
                                      : questionObj?.isChkReq &&
                                        questionObj?.isChkTxtReq
                                      ? q?.answer?.toLowerCase() ===
                                        'no'
                                        ? q?.answer
                                        : !q?.answer
                                        ? 'No'
                                        : 'Yes'
                                      : '',
                                  answerText: q?.answer,
                                  textareaAnswer:
                                    !questionObj?.isChkReq &&
                                    !questionObj?.isChkTxtReq
                                      ? q?.answer
                                      : questionObj?.isChkTxtReq &&
                                        q?.answer?.toLowerCase() !==
                                          'no'
                                      ? q?.answer
                                      : '',
                                },
                              };
                            },
                          ),
                        ],
                      };
                    },
                  )
                : [],
              policy: {
                startDate: reformData(
                  data?.viewProposal?.policy?.startDate,
                  '',
                ),
                endDate: reformData(
                  data?.viewProposal?.policy?.endDate,
                  '',
                ),
                time: reformData(
                  data?.viewProposal?.policy?.time,
                  '',
                ),
              },
              issuedPolicyData: {
                policyNo: '',
                receiptID: [],
                referenceNumber: '',
                digiLink: '',
                displayMessage: '',
                additionalMessage: '',
              },
              premiumDetails: {
                termsAndConditions: false,
                paymentMethod: '',
                payerType: '',
                onlinePayment: {
                  transactionId: '',
                },
                cdWallet: {
                  cdAccountNo: '',
                  cdAccountBalance: '',
                },
                cheque: [],
                demandDraft: [],
              },
            });
            updatePlanPremium(
              data?.viewProposal?.selectedPlanName,
              data?.viewProposal?.premium?.totalPremium,
            );
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    fetchViewProposalData();
  }, [dataCoversPlans, data, dataMyIntermediaries]);

  return loading || loadingSCPA ||
    loadingCoversPlans ||
    loadingRenewalMandateData ||
    loadingCustomerDetails ||
    loadingMyIntermediaries ? (
    <Loading />
  ) : error ||
    errorsCoversPlans ||
    errorRenewalMandateData ||
    errorCustomerDetails ||
    errorMyIntermediaries ? (
    <Error
      error={
        error ||
        errorsCoversPlans ||
        errorRenewalMandateData ||
        errorCustomerDetails ||
        errorMyIntermediaries
      }
    />
  ) : customerID?.toString()?.toLowerCase() ===
      data?.viewProposal?.customerID?.toString()?.toLowerCase() &&
    dataMyIntermediaries?.myIntermediaries?.find(
      (myIntermediary) =>
        myIntermediary?.intermediaryCode
          ?.toString()
          ?.toLowerCase() ===
        data?.viewProposal?.intermediaryDetails?.code
          ?.toString()
          ?.toLowerCase(),
    ) ? (
    <NewMotorPolicyIssuance
      startStep={3}
      isProposalNumberGenerated={true}
      customerID={customerID}
      planName={data?.viewProposal?.selectedPlanName}
      planCode={data?.viewProposal?.selectedPlanCode}
      lobCode={lobCode}
      lobName={lobName}
      productName={productName}
      productCode={productCode}
      proposalNumber={proposalNumber}
      stepsDisabled={[true, true, true, false, false]}
      breadcrumbNav={['Quote', 'View Proposal', 'Buy Policy']}
    />
  ) : customerID?.toString()?.toLowerCase() !==
    data?.viewProposal?.customerID?.toString()?.toLowerCase() ? (
    <Layout
      nav={['Quote', 'View Proposal', 'Buy Policy']}
      service_type={ClientService}
      title={`Your ${productName} Proposal`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Incorrect Customer ID for the given Proposal Number.
        </Text>
      </Card>
    </Layout>
  ) : (
    <Layout
      nav={['Quote', 'View Proposal', 'Buy Policy']}
      service_type={ClientService}
      title={`Your ${productName} Proposal`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Access denied.You are not allowed to view proposal belonging
          to another intermediary.
        </Text>
      </Card>
    </Layout>
  );
}
